import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import 'react-quill/dist/quill.snow.css'; // ES6
import { multiLineText } from '../../../../common/RegexValidation';
import objectId from '../../../../../helpers/objectId';
import TextEditor from '../../../../common/TextEditor';
var moment = require('moment');

class NotesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notes: ''
        }
    }

    close = () => {
        if (this.props.clickStatus === "addNote") {
            this.setState({ notes: '' })
        }
        else if (this.props.clickStatus === "editNote") {
            this.setState({ notes: this.state.notes })
        }
        this.props.notesClick(false, this.props.clickStatus);
    }

    addNotes = () => {

        if (this.props.clickStatus === "addNote") {
            let notesPayload = {
                _id: objectId(),
                content: this.state.notes,
                accountUserId: this.props.user._id,
                notedate: moment()
            }
            if (this.props.string === 'indesignPlaybook') {
                this.props.selectedData.id = this.props.selectedData._id;
                if (this.props.selectedData.notes && this.props.selectedData.notes.length > 0) {
                    (this.props.selectedData.notes).unshift(notesPayload)
                }
                else {
                    let notesArr = []
                    notesArr.push(notesPayload)
                    this.props.selectedData.notes = notesArr
                }
                dispatch.lifeCycle.updatePlaybookBySpecificFields({ _id: this.props.selectedData._id, notes: this.props.selectedData.notes });
                //this.props.selectedData.notes[0].accountUserId = this.props.user;
            }
            else if (this.props.string === 'playbookActivity') {
                this.props.selectedData.activityid = this.props.selectedData._id;
                if (this.props.selectedData.notes && this.props.selectedData.notes.length > 0) {
                    (this.props.selectedData.notes).unshift(notesPayload)
                }
                else {
                    let notesArr = []
                    notesArr.push(notesPayload)
                    this.props.selectedData.notes = notesArr
                }
                dispatch.lifeCycle.updatePlaybookActivities(this.props.selectedData);
            }

            this.close();

        }

        else if (this.props.clickStatus === "editNote") {
            let index = this.props.notes.findIndex(x => x._id === this.props.currentNote._id);
            let notesPayload = {
                _id: this.props.currentNote._id,
                content: this.state.notes ? this.state.notes : this.props.currentNote.content,
                accountUserId: this.props.currentNote.accountUserId,
                notedate: moment()
            }
            this.props.selectedData.notes[index] = notesPayload;

            if (this.props.string === 'indesignPlaybook') {
                this.props.selectedData.id = this.props.selectedData._id;
                dispatch.lifeCycle.updatePlaybookBySpecificFields({ _id: this.props.selectedData._id, notes: this.props.selectedData.notes })
                //this.props.selectedData.notes[this.props.selectedData.notes.length - 1].accountUserId = this.props.user;

            }
            else if (this.props.string === 'playbookActivity') {
                this.props.selectedData.activityid = this.props.selectedData._id;
                dispatch.lifeCycle.updatePlaybookActivities(this.props.selectedData);
            }
            this.close();
        }

    }

    updateText = (data, name) => {
        if (name === "Note") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ notes: '' })
            } else {
                this.setState({ notes: data })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.currentNote.content !== nextProps.currentNote.content) {
            this.setState({ notes: nextProps.currentNote.content })
        }
        if (nextProps.clickStatus === "addNote") {
            this.setState({ notes: '' })
        }
        else if (nextProps.clickStatus === "editNote") {
            this.setState({ notes: nextProps.currentNote.content })
        }
    }


    render() {
        return (
            <Modal
                className="NotesModalCard basicModal "
                open={this.props.open}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    {this.props.clickStatus === "editNote" ? "Edit Comment" : 'Add Comment'}
                </Modal.Header>
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    name="issue"
                    id="issueid"
                    onValidSubmit={() => { this.addNotes() }}
                >
                    <Modal.Content className="pad_20" scrolling>
                        <span className="head">{this.props.selectedData.name}</span>

                        <TextEditor
                            name="Note"
                            text={this.state.notes}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                            autoFocus={true}
                        />


                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button content='Cancel' className="button-cancel" onClick={this.close} />
                        {this.props.clickStatus === "editNote" ?
                            <Button type="submit" content='Update' disabled={this.state.notes.length === 0} className="button-submit" /> :
                            <Button type="submit" content='Add Comment' disabled={this.state.notes.length === 0} className="button-submit" />}
                    </Modal.Actions>
                </Form >
            </Modal>


        )
    }
}



export default NotesModal;